import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "remote-guid-container" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = {
  class: "left-part box-container",
  style: {"position":"relative"}
}
const _hoisted_4 = {
  key: 0,
  class: "dir-container"
}
const _hoisted_5 = {
  class: "right-part box-container",
  style: {"position":"relative"}
}
const _hoisted_6 = {
  key: 0,
  class: "dir-container"
}

import { defineComponent, ref, reactive, watch, onMounted, onBeforeUnmount, onUnmounted, getCurrentInstance,computed } from 'vue'
import {ChannelItem,keyTypeItem} from '@/types/baseInterFace'
import { getUserKeybinding } from '@/service'
import {useStore} from 'vuex'
import { $enum } from '@/global'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    leftJoyYaw: {
        type: Number,
        default: 0, // 左摇杆方向提示icon的角度 0-360 ，如果是-1 则不显示
    },
    rightJoyYaw: {
        type: Number,
        default: 0, // 右摇杆方向提示icon的角度 0-360 ，如果是-1 则不显示
    },
    isReady: {
        type: Boolean,
        default: false, // 遥控器是否准备好
    }
},
  setup(__props) {

//caac-新手教学遥控器方向指导部分
const props = __props

const leftArrowStyle = computed(() => ({
       transform: props.leftJoyYaw >= 0 ? `rotate(${props.leftJoyYaw}deg)` : 'none',
        transition: 'transform 0.1s ease-out' // 平滑旋转动画
    })
)

const rightArrowStyle = computed(() => ({
        transform: props.rightJoyYaw >= 0 ? `rotate(${props.rightJoyYaw}deg)` : 'none',
        transition: 'transform 0.1s ease-out' // 平滑旋转动画
    })
)

const store = useStore()
const state = reactive({
    leftX:50,
    leftY:50,
    leftYaw:0,
    rightX:50,
    rightY:50,
    rightYaw:0,
    isConnected:false,
    gamepad:null,
    buttuns:[],
    axes:[] as any[],
    animationFrameId:null,
    remoteID:null, // 手柄ID
    chanleList: [] as ChannelItem[],
    beforeChanleList:[] as ChannelItem[],
})
const { proxy } = getCurrentInstance()!

//监听连接
const handleConnected = async (event:any) => { 
    const gamepad = navigator.getGamepads()[event.gamepad.index]
    initGamepad(gamepad);
}

const initGamepad = async (gamepad:any) => { 
    if (!gamepad || (Array.isArray(gamepad.axes) && gamepad.axes.length == 0) || !gamepad.connected || (state.remoteID && gamepad.id &&  state.remoteID != gamepad.id)) {
        return
    }
    if(state.animationFrameId){
        cancelAnimationFrame(state.animationFrameId)
    }
    let axesArray: ChannelItem[] = []
    gamepad.axes.forEach((axis:any, index:any) => {
        let item: ChannelItem = {
            index: index + 1,
            name: `通道${index + 1}`,
            reverse: false,
            value: axis,
            value2: axis, //用于比较值变化控制抖动显示
            keyCode:"",
            keyName:"",
            keyValue:index,
            valueType:1,
            stickCenterValue:0,
            stickMinValue:-1,
            stickMaxValue:1,
            stickType:0,
        }
        axesArray.push(item)
    })
    Object.assign(state, {
        gamepad,
        isConnected: true,
        remoteID: gamepad.id,
        chanleList:[...axesArray],
        animationFrameId:null,
        beforeChanleList:[]
    })
    await getKeyBindData();
    updateGamepadState() 
}

//监听断开
const handleDisconnected = (event:any) => { 
    cancelAnimationFrame(state.animationFrameId)
    Object.assign(state, {
        leftX:50,
        leftY:50,
        leftYaw:0,
        rightX:50,
        rightY:50,
        rightYaw:0,
        isConnected:false,
        gamepad:null,
        buttuns:[],
        axes:[],
        remoteID:null,
        chanleList: [],
        beforeChanleList:[],
        animationFrameId:null
    })
}

//更新手柄信息
const updateGamepadState = ()=>{
    if(!state.isConnected) return
    const currentGamepad = navigator.getGamepads()[state.gamepad.index]
    if(!currentGamepad) return
    const updatedAxesArray = state.chanleList.map((ch, index) => {
        return { ...ch, value: currentGamepad.axes[index]};
    });
    state.chanleList = [...updatedAxesArray]

    state.chanleList.forEach((item, index) => {

        const {stickType,stickCenterValue,value,reverse } = item

        //处理摇杆中心值
        if([1,2,3,4].includes(stickType) && Math.abs(value - stickCenterValue) <= 0.05){
            item.value = stickCenterValue;
        }

        // 处理摇杆类型
        if(stickType >= 1 && stickType <= 4){
            const isYAxis = stickType == 2 || stickType == 4;
            const shouldReverse = isYAxis ? !reverse  : reverse;
            const value = inputToPercent(item,shouldReverse)
            const stateKey = getStateKey(stickType);
            const percent = Math.max(6, Math.min(94, value));
            state[stateKey] = percent;
        }
    })
    state.animationFrameId = requestAnimationFrame(updateGamepadState)
}

const inputToPercent = (item:any, reverse = false)=>{
    const leftRange = item.stickCenterValue - item.stickMinValue;
    const rightRange = item.stickMaxValue - item.stickCenterValue;
    let percent=0;
    if (item.value < item.stickCenterValue) {
        percent = 50 * (1 - (item.stickCenterValue - item.value) / (leftRange  || 1));
    } else {
        percent = 50 + 50 * ((item.value - item.stickCenterValue) / (rightRange || 1));
    }
    if (reverse) {
        percent = 100 - percent;
    }
    return percent
}

const getStateKey = (stickType:number | string)=>{ 
    return {
        1:'leftX',
        2:'leftY',
        3:'rightX',
        4:'rightY'
    }[stickType]
}

// 获取用户键位绑定数据
const getKeyBindData = async () => {
    let param = {
        userId:store.state.persistence.userInfo.userId,
        deviceType:1,
        joystickSpecification:state.remoteID
    }

    let {code,data} = await getUserKeybinding(param)
    if(code != $enum.EnumResult.SUCCESS){
        proxy?.vknMessage.error("获取遥控器数据失败！")
        return;
    }
    let {keyBindingList} = data as any || []
    if(Array.isArray(keyBindingList) && keyBindingList.length){
        keyBindingList.forEach((item:any,index:number)=>{
            let keyIndex = item.keyValue;
            if(item.valueType == 1 && state.chanleList[keyIndex]){
                Object.assign(state.chanleList[keyIndex],{
                    reverse:item.isInverse,
                    keyCode:item.keyCode,
                    keyName:item.keyName,
                    keyValue:item.keyValue,
                    valueType:item.valueType,
                    stickCenterValue:item.stickCenterValue,
                    stickMinValue:item.stickMinValue,
                    stickMaxValue:item.stickMaxValue,
                    stickType:item.stickType,
                });
            }
        })
    }
}

onMounted(()=>{
    window.addEventListener('gamepadconnected', handleConnected);
    window.addEventListener('gamepaddisconnected', handleDisconnected);

    //检测到已经连接的手柄
    const gamepads = navigator.getGamepads();
    if(gamepads[0]){
        initGamepad(gamepads[0]);
    }
})

onBeforeUnmount(()=>{
    window.removeEventListener('gamepadconnected', handleConnected);
    window.removeEventListener('gamepaddisconnected', handleDisconnected);
    cancelAnimationFrame(state.animationFrameId)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "horizontal-line line" }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "vertical-line line" }, null, -1)),
        (__props.isReady && __props.leftJoyYaw != -1 && state.isConnected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "ball-inner",
                style: _normalizeStyle(leftArrowStyle.value)
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "image-box" }, null, -1)
              ]), 4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "ball-container",
          style: _normalizeStyle({left:`${state.leftX}%`, top:`${state.leftY}%`})
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "horizontal-line line" }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "vertical-line line" }, null, -1)),
        (__props.isReady && __props.rightJoyYaw != -1 && state.isConnected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "ball-inner",
                style: _normalizeStyle(rightArrowStyle.value)
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "image-box" }, null, -1)
              ]), 4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "ball-container",
          style: _normalizeStyle({left:`${state.rightX}%`, top:`${state.rightY}%`})
        }, null, 4)
      ])
    ])
  ]))
}
}

})